class BESSAppProjectRainwaterTankEditorManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
    }

    onInputChanged(input, value) {
        if(input.field.variable === "willThisTankBeConnectedToTheReticulatedThirdPipeOrOnsiteWaterRecyclingSystem") {
            this.#thirdPipeConnectionChanged(input, value);
        }
    }


    #thirdPipeConnectionChanged(input, value) {
        if (value != null && value) {
            this.askUserToConfirm(
                "Connected to the reticulated third pipe or onsite water recycling system",
                "Confirm connect to the reticulated third pipe or onsite water recycling system? This tank will not be available to be connected to a hot water system.",
                function() {

                },
                "Yes",
                "No",
                function() {
                    input.setValue(false);
                }
            );
            return false;
        }
        return true;
    }

}